export default "__VITE_ASSET__BdILuRqc__"